import { Mail, Phone, MapPin } from "lucide-react";
import { FaFacebookF, FaInstagram, FaWhatsapp, FaArrowUp } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assets/image/cclog.png";
import { useState, useEffect } from "react";

function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <footer className="bg-blue-900 text-white relative">

        {/* Main Grid */}
        <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-5 gap-10">

          {/* Logo */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src={logo}
                alt="logo"
                className="w-14 h-14 bg-white rounded-full p-1"
              />
              <h3 className="text-xl font-bold text-yellow-400">
                Capitol Public School
              </h3>
            </div>

            <p className="text-gray-300 text-sm leading-relaxed">
              Excellence • Discipline • Leadership
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-yellow-400 font-bold mb-4">Quick Links</h4>

            <ul className="space-y-2 text-gray-300">
              <li><Link to="/" className="hover:text-yellow-400">Home</Link></li>
              <li><Link to="/our-genesis" className="hover:text-yellow-400">About</Link></li>
              <li><Link to="/infrastructure" className="hover:text-yellow-400">Infrastructure</Link></li>
              <li><Link to="/careers" className="hover:text-yellow-400">Careers</Link></li>
              <li><Link to="/contact" className="hover:text-yellow-400">Contact</Link></li>
            </ul>
          </div>

          {/* Important Links */}
          <div>
            <h4 className="text-yellow-400 font-bold mb-4">Important Links</h4>

            <ul className="space-y-2 text-gray-300 text-sm">
              <li>
                <Link to="/rules" className="hover:text-yellow-400">
                  School Rules & Regulations
                </Link>
              </li>
              <li>
                <Link to="/schedule" className="hover:text-yellow-400">
                  School Schedule
                </Link>
              </li>
              <li>
                <Link to="/uniform" className="hover:text-yellow-400">
                  School Uniform
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-yellow-400 font-bold mb-4">Contact</h4>

            <div className="space-y-3 text-sm text-gray-300">

              <div className="flex gap-2">
                <MapPin size={16} />
                Mysuru - 570009, Karnataka
              </div>

              <a href="tel:+918970745451" className="flex gap-2 hover:text-yellow-400">
                <Phone size={16} />
                +91 8970745451
              </a>

              <a href="mailto:capitolmysuru@gmail.com" className="flex gap-2 hover:text-yellow-400">
                <Mail size={16} />
                capitolmysuru@gmail.com
              </a>

            </div>
          </div>

          {/* Social + Map */}
          <div>
            <h4 className="text-yellow-400 font-bold mb-4">Follow Us</h4>

            <div className="flex gap-4 mb-6">

              <a className="bg-white/10 p-3 rounded-full hover:bg-yellow-400 hover:text-blue-900 transition">
                <FaFacebookF />
              </a>

              <a className="bg-white/10 p-3 rounded-full hover:bg-yellow-400 hover:text-blue-900 transition">
                <FaInstagram />
              </a>

            </div>

            {/* Map */}
            <div className="rounded-xl overflow-hidden shadow">
              <iframe
                title="school location"
                src="https://maps.google.com/maps?q=mysuru&t=&z=13&ie=UTF8&iwloc=&output=embed"
                className="w-full h-32 border-0"
                loading="lazy"
              ></iframe>
            </div>

          </div>

        </div>

        {/* Bottom */}
        <div className="border-t border-white/20 text-center py-4 text-sm text-gray-300">
          © {new Date().getFullYear()} Capitol Public School. All rights reserved.
        </div>
      </footer>

      {/* WhatsApp Floating */}
      <a
        href="https://wa.me/918970745451"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 left-6 bg-green-500 p-4 rounded-full text-white shadow-lg hover:scale-110 transition z-50"
      >
        <FaWhatsapp size={22} />
      </a>

      {/* Scroll to Top */}
      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 bg-yellow-400 text-blue-900 p-3 rounded-full shadow-lg hover:scale-110 transition z-50"
        >
          <FaArrowUp />
        </button>
      )}
    </>
  );
}

export default Footer;
